export default {
    data() {
        return {
            form: {}
        }
    },
    methods: {

        // 登录到权限管理，进行输入验证
        login() {
            if (this.$isAbnormal(this.form.name)) {
                this.$message({
                    message: '请输入用户名',
                    type: 'error'
                })
                return
            } else if (this.$isAbnormal(this.form.password)) {
                this.$message({
                    message: '请输入密码',
                    type: 'error'
                })
                return
            }
            this.loginByNameAndPwd()
        },

        // 用户名密码登录
        loginByNameAndPwd() {
            this.$post('authority_management_user/login', {
                name: this.form.name,
                password: this.form.password,
                shop_id: 8
            }).then(res => {
                if (res.status === 200) {

                    // 用户登录成功才会有result返回
                    if (!this.$isAbnormal(res.data.result)) {

                        // 将权限管理员的token存入缓存
                        sessionStorage.setItem('authid', res.data.result.token)
                        // 将权限管理员的token存入状态管理authority_management
                        this.$store.state.authority_management = res.data.result.token

                        // this.getAuthority(res.data.result.token)
                        
                        // 获取店铺信息
                        this.getShopInfo()
                    } else {
                        this.$message({
                            message: '用户名或密码错误',
                            type: 'error'
                        })
                    }
                }
            })
        },

        // 根据登录返回的token获取权限数据
        getAuthority(token) {
            this.$post('authority_management_user/get', {
                token: token
            }).then(res => {
                // 将数据存到缓存中，使用router传递数据的话刷新会数据就丢失了
                let authorizationObject = res.data.result
                sessionStorage.setItem('authorizationObject', JSON.stringify(authorizationObject))
                // 跳转到后台管理首页
                this.$router.push({
                    name: 'coursestoremanagement'
                })
            })
        },

        // 直接进入后台管理获取店铺信息
        getShopInfo() {
            this.$post('shops/get', { id: 8 }).then(res => {
                this.$store.state.store = res.data.result
                sessionStorage.setItem("store", JSON.stringify(this.$store.state.store))

                // 获取权限数据
                this.getAuthority(this.$store.state.authority_management)
            })
        },
    }
}